import React, { Fragment, Component } from 'react'
import { connect } from 'react-redux'
import ClockDissolve from '../components/ClockDissolve'
import { withStyles } from '@material-ui/core/styles'
import { makeGetPaint } from '../selectors/paintSelector'
import format from 'date-fns/format'
import parseDate from '../utility/parseDate'

const id = 'Sentinel2PipelineChangeDetection'
const datetimeId = 'PipelineChangeDetection'
const datetimeIdBase = 'PipelineChangeDetectionBase'

const styles = {
  container: {
    position: 'absolute',
    bottom: '50px',
    right: '150px'
  }
}

class ClockDissolveContainer extends Component {
  render () {
    const { classes, paint, time, timeBase, showDissolveClock } = this.props
    if (!showDissolveClock) {
      return null
    }
    
    const ratio = paint ? paint['raster-opacity'] : 1

    const dateTop = format(parseDate(time ? time : new Date()), "dd LLLL yyyy")
    const dateBottom = format(parseDate(timeBase ? timeBase : new Date()), "dd LLLL yyyy")

    return (
      <div className={classes.container} >
        <ClockDissolve ratio={ratio} dateTop={dateTop} dateBottom={dateBottom} />
      </div>
    )
  }
}

const mapStateToProps = state => {
  const getPaint = makeGetPaint()
  const paintId = 'Sentinel2PipelineChangeDetection'
  const serviceId = state.serviceCard.name

  if (serviceId === 'Energir') {
    const time = state.layer.times[serviceId]

    return {
      ratio: {},
      paint: getPaint(state, serviceId),
      time: time,
      timeBase: time - (24*60*60*1000) * 7,
      showDissolveClock: state.service.serviceCardActive.showDissolveClock
    }
  }
  return {
    ratio: {},
    paint: getPaint(state, paintId),
    time: state.layer.times[datetimeId] || undefined,
    timeBase: state.layer.times[datetimeIdBase] || undefined,
    showDissolveClock: state.service.serviceCardActive.showDissolveClock
  }
}

export default connect(mapStateToProps, null)(withStyles(styles)(ClockDissolveContainer))



// WEBPACK FOOTER //
// ./src/containers/ClockDissolveContainer.js